<template>
  <div class="site-section team">
    <div class="site-container">
      <h2>
        <img src="@/assets/img/svg/icon.svg" width="25" />
        Conheça nossos sócios
      </h2>
      <h3>
       Especialistas nas áreas trabalhista, previdenciária, sindical, civil e direito médico com mais de 30 anos de experiência
      </h3>
      <scrollable-content container-class="team-members" :show-mobile="false">
        <router-link
          class="team-member-item"
          :to="{
            name: 'team_detail',
            params: { slug: member.slug },
          }"
          v-for="member in items"
          :key="`team-member-i${member.id}`"
        >
          <div class="team-member-item-image">
            <logo-icon />
            <img
              v-if="member.image"
              :src="member.image"
              height="150"
            />
          </div>
          <p class="team-member-item-name">{{ member.name }}</p>
          <p class="team-member-item-position">
            {{ member.text }}
          </p>
          <div class="text-center">
            <span>VER PERFIL</span>
            <arrow-horizontal width="20" />
          </div>
        </router-link>
      </scrollable-content>

      <div class="text-center hidden-mobile" style="margin-top: 2rem">
        <router-link :to="{ name: 'page_team' }" class="button button-orange"
          >VER EQUIPE</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import ArrowHorizontal from "@/components/Svg/ArrowHorizontal.vue";
import ScrollableContent from "@/components/ScrollableContent";
import LogoIcon from "@/components/Svg/LogoIcon";
// import team_members from "@/data/team.js";

export default {
  components: { ArrowHorizontal, LogoIcon, ScrollableContent },
  props: ["items"],
  methods: {}
};
</script>
